import { useIsNative } from "@/lib/platform";
import { useProfile } from "@/lib/api";

/**
 * Whether to pitch the native app to this user: they're on the web and have no
 * app device registered. The pre-dinner reminder ladder is delivered as
 * Customer.io broadcasts, and Customer.io only ever holds ios/android tokens —
 * so a web-only user cannot receive any of those push nudges.
 */
export function useShouldPitchAppInstall(): boolean {
  const isNative = useIsNative();
  const { data } = useProfile();
  // Default to "has the app" so the pitch stays hidden until the profile
  // actually says otherwise.
  const hasAppDevice = data?.data?.hasAppDevice ?? true;
  return !isNative && !hasAppDevice;
}
